import React, { useContext, useState } from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
// import { Button } from 'reactstrap';
import { Modal, Row, Col, Button, Card } from "react-bootstrap";
import axios from "axios";

import { FormattedMessage, useIntl } from "react-intl";
import { gql, useMutation } from "@apollo/client";
import * as Sentry from "@sentry/react";
import Swal from "sweetalert2";
import ReactSwitch from "../../helpers/formik/advance-switch";
import UserContext from "../../contexts/user";
import { AuthContext } from "../../containers/user-auth";
import { useApolloClient, useQuery } from "@apollo/client";
import AlertModal from "../../components/alert-modal";

const Signup: React.FC = () => {
  const intl = useIntl();
  const userContext = useContext(UserContext);
  const authContext = useContext(AuthContext);
  const apolloClient = useApolloClient();

  const { currentEvent } = userContext;
  const { setPage, login } = authContext;
  const redirectUrl = window.location.href;

  const slug = document.location.pathname.split("/")[1] || "invalid";
  const [showAlertModal, setShowAlertModal] = useState(false);
  const handleAlertModal = () => {
    setShowAlertModal(!showAlertModal);
  };
  const [alertType, setAlertType] = useState("");

  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  // const emailCheck = await apolloClient.query({
  //   query: gql`
  //     query (
  //       $email: String
  //       $event_id: String!
  //     ) {
  //       email: user(where: {
  //         email: {
  //           _eq: $email
  //         }
  //         event_id: {
  //           _eq: $event_id
  //         }
  //       }) {
  //         id
  //       }
  //     }
  //   `,
  //   variables: {
  //     email: values.email,
  //     event_id,
  //   },
  //   fetchPolicy: "network-only"
  // });
  // const [insert_user_one, { loading }] = useMutation(
  //   gql`
  //     mutation insert_user_one($object: user_insert_input!) {
  //       insert_user_one(object: $object) {
  //         event_id
  //         id
  //       }
  //     }
  //   `,
  //   {
  //     onError: (e) => {
  //        console.log("error in signup page --------------------------------", e);
  //       if (e.graphQLErrors && e.graphQLErrors.length > 0) {
  //         if (e.graphQLErrors[0].extensions?.code === "constraint-violation") {
  //           Swal.fire({
  //             title: "Error!",
  //             text: "Login not available",
  //             icon: "error",
  //           });
  //           return;
  //         }
  //       }
  //       Swal.fire({
  //         title: "Error!",
  //         text: "There was an error while creating your account.",
  //         icon: "error",
  //       });
  //       Sentry.captureException(e);
  //     },
  //     onCompleted: (resp) => {
  //       Swal.fire({
  //         title: "Signup success!",
  //         text: "Account was created successfully. Please wait while we log you in.",
  //         icon: "success",
  //       });
  //     },
  //   }
  // );

  return (
    <>
      <Formik
        initialValues={{
          name: "",
          email: "",
          password: "",
        }}
        onSubmit={async (values) => {
           console.log("values  in side  signup page", values);
         
          setLoading(true);
          await axios
            .post(
              `${process.env.REACT_APP_API_ENDPOINT}/api/event-engagement/${slug}/user-signup`,

              {
                name: values.name,
                email: values.email,
                password: values.password,
                redirect: redirectUrl,
                
              }
            )
            .then((response) => {
               console.log(
                "response.data.data--------------------------------------------------------------",
                response.data.data
              );
              setLoading(false);

              setAlertType("Success");
              setMessage("user created  sucessfully please validate from e-mail");
              setShowAlertModal(true);
              // land to log in page
              // setPageCallback();
            })
            .catch((error) => {
               console.log(error);
              setLoading(false);

              setAlertType("Error");
              setMessage(`${error.message}`);
              setShowAlertModal(true);
            });
        }}
      >
        {({ values }) => {
          return (
            <Form className="m-t-30">
              <h4>
                <FormattedMessage id="signup.header" />
              </h4>
              <div className="form-group m-t-10">
                <Field
                  required
                  placeholder={intl.formatMessage({ id: "input.name" })}
                  className="form-control"
                  type="text"
                  // name="login"
                  name="name"
                />
                <ErrorMessage
                  className="invalid-feedback"
                  name="login"
                  component="div"
                />
              </div>
              <div className="form-group m-t-10">
                <Field
                  required
                  placeholder={intl.formatMessage({ id: "input.email" })}
                  className="form-control"
                  type="email"
                  name="email"
                />
                <ErrorMessage
                  className="invalid-feedback"
                  name="email"
                  component="div"
                />
              </div>
              <div className="form-group">
                <Field
                  required
                  placeholder={intl.formatMessage({ id: "input.password" })}
                  className="form-control"
                  type="password"
                  name="password"
                  minLength="6"
                />
                <ErrorMessage
                  className="invalid-feedback"
                  name="password"
                  component="div"
                />
              </div>
              {/* // modification  */}
              {/* <div
          className="form-group "
          style={{
            margin: "0px 135px 30px 135px",
          }}
        >
          <Card className="img-upload bg-gray">
            <Card.Body>
              <Field
                // component={ImageUploadCustom}
                id="picture"
                name="picture"
                defaultImage="/images/profile-ico-img.png"
                accept="image/*"
                buttonEmpty="label.uploadPhoto"
                buttonUploaded={intl.formatMessage({
                  id: "label.logoUploaded",
                })}
                maxSize={process.env.REACT_APP_IMAGE_FILE_SIZE_MAX}
              />
            </Card.Body>
          </Card>
        </div> */}
              {/* <Row>
          <Col>
            <Field
              component={ReactSwitch}
              name="is_moderator"
              id="is_moderator"
              label={intl.formatMessage({
                id: "input.audience.moderator",
              })}
              offColor="#b1b1b1"
              onColor="#f9962e"
            />
          </Col>
          <Col>
            <Field
              component={ReactSwitch}
              name="disabled"
              id="disabled"
              offColor="#b1b1b1"
              onColor="#f9962e"
              label={intl.formatMessage({
                id: values.disabled ? "input.audience.blocked" : "input.audience.unblocked",
              })}
            />
          </Col>
        </Row> */}
              {/* // */}
              <div className="login-button-container m-t-20">
                {/* {currentEvent.allowAnonymousAccess ? (
              <Button
                onClick={function () {
                  userContext.setOneTimeShowLogin(false);
                  userContext.setShowLogin(false);
                }}
                color="link"
                type="button"
              >
                <span
                  dangerouslySetInnerHTML={{
                    __html: intl.formatMessage({
                      id: "auth.continue.without.login",
                    }),
                  }}
                ></span>
              </Button>
            ) : (
              <span />
            )} */}
                {currentEvent.allowAnonymousAccess ? (
                  <Button
                    style={{
                      backgroundColor: "white",
                      // color: "black",
                      // textAlign: "left",
                      // fontSize: "12px",
                      // paddingLeft: "0px",
                      // fontWeight: 400,
                      // textDecoration: "none",
                    }}
                    className="btn btn-link"
                    onClick={function () {
                      userContext.setShowLogin(false);
                    }}
                    color="link"
                    type="button"
                  >
                    <span
                      // style={{
                      //   fontSize: "12px",
                      // }}
                      dangerouslySetInnerHTML={{
                        __html: intl.formatMessage({
                          id: "auth.continue.without.login",
                        }),
                      }}
                    ></span>
                  </Button>
                ) : (
                  <span />
                )}
                <div>
                  <Button color="primary" type="submit" disabled={loading}>
                    <FormattedMessage id="common.enter.button" />
                  </Button>
                </div>
              </div>
              <div className="common-styles m-t-20">
                {intl.formatMessage({ id: "have.account" })}
                &nbsp;&nbsp;
                <Button
                style={{background: "#fff"}}
                  onClick={function () {
                    userContext.setOneTimeShowLogin(false);
                    setPage("login");
                  }}
                  color="link"
                  type="button"
                  className="btn btn-link"
                >
                  {intl.formatMessage({ id: "button.signin" })}
                </Button>
              </div>
            </Form>
          );
        }}
      </Formik>
      <AlertModal
        show={showAlertModal}
        handleClose={handleAlertModal}
        type={alertType}
        message={message}
      />
    </>
  );
};

export default Signup;
